import React from 'react';
import router from 'next/router';

import { Button, Text } from '@BICE_Vida/components';
import { Container } from '@BICE_Vida/scp-components';

import styles from './PricesAndPlansHero.module.scss';

import componentsId from '../../../utils/componentsId';
import routes from '../../../utils/routes';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { planPageBaseLayer, planPageEvents } from '@/utils/dataLayer/planPage';

type CoveragesHeroT = {
  title: string;
  text: string;
  btn: string;
};

function PricesAndPlansHero({ title, text, btn }: CoveragesHeroT) {
  const btnEstimateClick = () => {
    trackEvent({
      eventParams: {
        ...planPageBaseLayer,
        ...planPageEvents.clickQuoteHero,
      },
    });
    router.push(routes.wizardPlan);
  };

  return (
    <section
      id={componentsId.pricesAndPlans.hero.section}
      className={styles.prices_and_plans_hero_section}
    >
      <Container>
        <Text tag="h1" fontTypo="display-large">
          {title}
        </Text>
        <Text>{text}</Text>
        <Button
          id={componentsId.pricesAndPlans.hero.button}
          iconPosition="right"
          onClick={btnEstimateClick}
          size="large"
          text={btn}
          variant="primary"
          icon="arrow_forward"
        />
      </Container>
    </section>
  );
}

export default PricesAndPlansHero;
